import { type MainTabNavigationItem } from './types/main-tab-navigation-item.interface';

export const MAIN_TAB_NAVIGATION_ITEMS: readonly MainTabNavigationItem[] = [
  {
    id: 'timeline',
    label: 'Start',
    iconName: 'clock',
    ariaLabel: 'Otwórz Start',
    route: '/timeline',
  },
  {
    id: 'library',
    label: 'Biblioteka',
    iconName: 'book-marked',
    ariaLabel: 'Otwórz Bibliotekę',
    route: '/library',
  },
  {
    id: 'people',
    label: 'Osoby',
    iconName: 'users',
    ariaLabel: 'Otwórz Osoby',
    route: '/people',
  },
  {
    id: 'wishlists',
    label: 'Listy',
    iconName: 'heart',
    ariaLabel: 'Otwórz Listy',
    route: '/wishlists',
  },
] as const;
